export const LOCALES = [
  { code: 'en', native: 'English', flagIndex: 1 },
  { code: 'pt', native: 'Português', flagIndex: 0 },
  { code: 'es', native: 'Español', flagIndex: 2 },
  { code: 'fr', native: 'Français', flagIndex: 3 },
  { code: 'de', native: 'Deutsch', flagIndex: 4 },
  { code: 'it', native: 'Italiano', flagIndex: 5 },
];

export const DEFAULT_LOCALE = 'en';

const STORY = {
  en: 'Stray Pixel Games is a small game company that made Pocket Game Developer. That started because Mushroomavocado was in a meeting and was bored and wished she could make a game on her phone. Cardanis was working on a UI Library at the time and Mushroomavocado thought it would be cool to turn it into a game engine. So we did.',
  pt: 'A Stray Pixel Games é uma pequena empresa de jogos que criou o Pocket Game Developer. Tudo começou porque Mushroomavocado estava numa reunião, entediada, e queria poder fazer um jogo no celular. Cardanis estava trabalhando numa biblioteca de interface na época, e Mushroomavocado achou que seria legal transformá-la num motor de jogos. E foi o que a gente fez.',
  es: 'Stray Pixel Games es una pequeña compañía de juegos que hizo Pocket Game Developer. Todo empezó porque Mushroomavocado estaba en una reunión, se aburría y quería poder hacer un juego en el teléfono. Cardanis estaba trabajando en una biblioteca de interfaz en ese momento, y a Mushroomavocado le pareció genial convertirla en un motor de juegos. Y eso hicimos.',
  fr: 'Stray Pixel Games est un petit studio de jeux qui a créé Pocket Game Developer. Tout a commencé parce que Mushroomavocado s’ennuyait en réunion et aurait voulu pouvoir faire un jeu sur son téléphone. Cardanis travaillait alors sur une bibliothèque d’interface, et Mushroomavocado s’est dit que ce serait chouette d’en faire un moteur de jeu. Alors on l’a fait.',
  de: 'Stray Pixel Games ist eine kleine Spielefirma, die Pocket Game Developer gemacht hat. Angefangen hat es, weil Mushroomavocado in einem Meeting saß, sich langweilte und sich wünschte, sie könnte ein Spiel auf dem Handy machen. Cardanis arbeitete damals an einer UI-Bibliothek, und Mushroomavocado fand, es wäre cool, daraus eine Spiel-Engine zu machen. Also haben wir das getan.',
  it: 'Stray Pixel Games è una piccola software house che ha creato Pocket Game Developer. Tutto è iniziato perché Mushroomavocado era in una riunione, si annoiava e avrebbe voluto poter fare un gioco sul telefono. Cardanis in quel periodo lavorava a una libreria di interfaccia, e Mushroomavocado ha pensato che sarebbe stato bello trasformarla in un motore di gioco. E così abbiamo fatto.',
};

export const siteCopy = {
  en: {
    nav: { home: 'Home', games: 'Pocket Dev', about: 'About us', language: 'Language', destroyer: 'Destroyer' },
    play: 'Play',
    tagline: 'What you make matters',
    pocketDev: 'Pocket Game Developer',
    pocketDevDescription: "It's a game creation app. You can make games in it. You can also make animations, sound effects, game objects, levels and then put them all together into a game. It wants to be a game engine when it grows up.\n\nFits in your pocket. You will have to remove from your pocket to make a game.",
    file: 'File',
    open: 'Open',
    close: 'Close',
    story: STORY.en,
    president: 'President',
    otherPresident: 'Other President',
    minimize: 'Minimize',
    maximize: 'Maximize',
    restore: 'Restore',
  },
  pt: {
    nav: { home: 'Início', games: 'Pocket Dev', about: 'Sobre nós', language: 'Idioma', destroyer: 'Destroyer' },
    play: 'Jogar',
    tagline: 'O que você cria importa',
    pocketDev: 'Pocket Game Developer',
    pocketDevDescription: 'É um app de criação de jogos. Você pode fazer jogos nele. Também pode fazer animações, efeitos sonoros, objetos de jogo, fases e depois juntar tudo num jogo. Ele quer ser um motor de jogos quando crescer.\n\nCabe no seu bolso. Você vai ter que tirar do bolso para fazer um jogo.',
    file: 'Arquivo',
    open: 'Abrir',
    close: 'Fechar',
    story: STORY.pt,
    president: 'Presidenta',
    otherPresident: 'Outro presidente',
    minimize: 'Minimizar',
    maximize: 'Maximizar',
    restore: 'Restaurar',
  },
  es: {
    nav: { home: 'Inicio', games: 'Pocket Dev', about: 'Sobre nosotros', language: 'Idioma', destroyer: 'Destroyer' },
    play: 'Jugar',
    tagline: 'Lo que creas importa',
    pocketDev: 'Pocket Game Developer',
    pocketDevDescription: 'Es una app para crear juegos. Puedes hacer juegos en ella. También puedes hacer animaciones, efectos de sonido, objetos de juego, niveles y luego juntarlo todo en un juego. Quiere ser un motor de juegos cuando crezca.\n\nCabe en tu bolsillo. Tendrás que sacarlo del bolsillo para hacer un juego.',
    file: 'Archivo',
    open: 'Abrir',
    close: 'Cerrar',
    story: STORY.es,
    president: 'Presidenta',
    otherPresident: 'Otro presidente',
    minimize: 'Minimizar',
    maximize: 'Maximizar',
    restore: 'Restaurar',
  },
  fr: {
    nav: { home: 'Accueil', games: 'Pocket Dev', about: 'À propos', language: 'Langue', destroyer: 'Destroyer' },
    play: 'Jouer',
    tagline: 'Ce que tu crées compte',
    pocketDev: 'Pocket Game Developer',
    pocketDevDescription: 'C’est une appli pour créer des jeux. Tu peux y faire des jeux. Tu peux aussi faire des animations, des effets sonores, des objets de jeu, des niveaux, puis tout assembler en un jeu. Il veut devenir un moteur de jeu quand il sera grand.\n\nIl tient dans ta poche. Il faudra le sortir de ta poche pour faire un jeu.',
    file: 'Fichier',
    open: 'Ouvrir',
    close: 'Fermer',
    story: STORY.fr,
    president: 'Présidente',
    otherPresident: 'Autre président',
    minimize: 'Réduire',
    maximize: 'Agrandir',
    restore: 'Restaurer',
  },
  de: {
    nav: { home: 'Start', games: 'Pocket Dev', about: 'Über uns', language: 'Sprache', destroyer: 'Destroyer' },
    play: 'Spielen',
    tagline: 'Was du erschaffst, zählt',
    pocketDev: 'Pocket Game Developer',
    pocketDevDescription: 'Es ist eine App zum Spieleentwickeln. Du kannst darin Spiele machen. Du kannst auch Animationen, Soundeffekte, Spielobjekte und Level machen und dann alles zu einem Spiel zusammensetzen. Es will eine Spiel-Engine werden, wenn es groß ist.\n\nEs passt in deine Tasche. Du musst es aus der Tasche nehmen, um ein Spiel zu machen.',
    file: 'Datei',
    open: 'Öffnen',
    close: 'Schließen',
    story: STORY.de,
    president: 'Präsidentin',
    otherPresident: 'Anderer Präsident',
    minimize: 'Minimieren',
    maximize: 'Maximieren',
    restore: 'Wiederherstellen',
  },
  it: {
    nav: { home: 'Home', games: 'Pocket Dev', about: 'Chi siamo', language: 'Lingua', destroyer: 'Destroyer' },
    play: 'Gioca',
    tagline: 'Ciò che crei conta',
    pocketDev: 'Pocket Game Developer',
    pocketDevDescription: 'È un’app per creare giochi. Ci puoi fare dei giochi. Puoi anche fare animazioni, effetti sonori, oggetti di gioco, livelli e poi metterli tutti insieme in un gioco. Vuole diventare un motore di gioco quando sarà grande.\n\nSta in tasca. Dovrai tirarlo fuori dalla tasca per fare un gioco.',
    file: 'File',
    open: 'Apri',
    close: 'Chiudi',
    story: STORY.it,
    president: 'Presidente',
    otherPresident: 'Altro presidente',
    minimize: 'Riduci',
    maximize: 'Ingrandisci',
    restore: 'Ripristina',
  },
};

export function isLocale(value) {
  return LOCALES.some((locale) => locale.code === value);
}
